var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PublicPageMenuEntry,{attrs:{"id":_vm.id,"click-only":"","icon":_vm.icon,"href":_vm.href,"label":_vm.label},on:{"click":_setup.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }